export default __webpack_public_path__ + "static/media/post10.826724aa.jpg";